import React from "react";
import Form from 'react-bootstrap/Form';

function CustomFormInput({ id, label, type, placeholder, name, className = "", value, onChange, noThemeClass = false, ...other }) {
  const groupClassName = noThemeClass ? className : `theme-input ${className}`;
  return (
    <Form.Group controlId={id} className={groupClassName}>
      {label && <Form.Label>{label}</Form.Label>}
      <Form.Control type={type} placeholder={placeholder} value={value} name={name} onChange={onChange} {...other} autoComplete="off" />
    </Form.Group>
  );
}

export default CustomFormInput;
